import { getCardNumberBrand, formatCreditCardFields, validateCreditCardFields, CreditCard } from '@dlocal-int/credit-card-expert/lib/js';
import { CreditCardData } from '../interfaces';
import { removeNaNAndEmpty, formatYear, formatMonth } from '../utils/formatter';
import { ERRORS } from '../constants';

export const hasTwoChars = (txt: string) => {
    return txt && typeof txt === 'string' && txt.match(/^([A-Z,a-z]){2}$/) !== null;
};

function getCardErrors(state: CreditCardData, cardObject: CreditCard) {
    // Use the country code from the state for language detection
    const errors = ERRORS(state.country);

    let nameError;
    let countryError;

    if (!state.name) {
        nameError = errors.HOLDER_NAME_ERROR;
    }

    if (!hasTwoChars(state.country)) {
        countryError = errors.COUNTRY_ERROR.message;
    }

    const brandDetectResult = getCardNumberBrand(cardObject.number, state.country);
    let fieldsValues = formatCreditCardFields(cardObject, brandDetectResult);

    const validationErrors = validateCreditCardFields(fieldsValues, false, false, false, brandDetectResult, false, false);

    let fieldsErrors = {
        cvv: !validationErrors.cvv ? errors.CVV_ERROR : null,
        number: !validationErrors.number ? errors.CCNUMBER_ERROR : null,
        expiration: !validationErrors.expiration ? errors.EXP_ERROR : null,
        name: nameError ? nameError : null,
        country: countryError ? countryError : null
    };

    if (!cardObject.number) {
        fieldsErrors.number = errors.CCNUMBER_ERROR;
    }

    return fieldsErrors;
}

export const getDataErrors = async (data: CreditCardData) => {
    // @ts-ignore

    const formatedCvv = removeNaNAndEmpty(data.cvv);
    const formatedPan = removeNaNAndEmpty(data.pan);
    const formatedMonth = formatMonth(data.expirationMonth);
    const formatedYear = formatYear(data.expirationYear);
    const formatedDate = formatedMonth + '/' + formatedYear;

    const ccFields = {
        cvv: formatedCvv,
        number: formatedPan,
        expiration: formatedDate
    };

    let expertErrors = getCardErrors(data, ccFields);
    let hasErrors = false;
    let errors = {};

    Object.keys(expertErrors).forEach((key) => {
        if (expertErrors[key]) {
            hasErrors = true;
            errors[key] = expertErrors[key];
        }
    });

    return hasErrors ? errors : null;
};
